﻿import Editor from "@arcgis/core/widgets/Editor";
import Graphic from "@arcgis/core/Graphic";
import {DotNetGraphic, DotNetQuery} from "./definitions";
import {buildJsFormTemplate, buildJsGraphic} from "./jsBuilder";
import CreationInfo = __esri.CreationInfo;
import FeatureLayerWrapper from "./featureLayer";
import { graphicsRefs } from "./arcGisJsInterop";
import * as Core from "./arcGisJsInterop";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import LayerInfo = __esri.LayerInfo;

export default class EditorWidgetWrapper {
    private editor: Editor;
    
    constructor(editor: Editor) {
        this.editor = editor;
    }
    
    getActiveWorkflow(): any {
        return this.editor.activeWorkflow;
    }
    
    setLayerInfos(dotNetLayerInfos: any) {
        let layerInfos: LayerInfo[] = [];
        for (let i = 0; i < dotNetLayerInfos.length; i++) {
            let layerInfo : LayerInfo = {
                layer: Core.arcGisObjectRefs[dotNetLayerInfos[i].id] as FeatureLayer
            };
            if (dotNetLayerInfos[i].formTemplate !== undefined &&
                dotNetLayerInfos[i].formTemplate !== null) {
                layerInfo.formTemplate = buildJsFormTemplate(dotNetLayerInfos[i].formTemplate);
            }
            layerInfos.push(layerInfo);
        }
        this.editor.layerInfos = layerInfos;
    }
    
    async cancelWorkflow() {
        await this.editor.cancelWorkflow();
    }
    
    async deleteFeatureFromWorkflow() {
        await this.editor.deleteFeatureFromWorkflow();
    }
    
    async startCreateFeaturesWorkflowAtFeatureCreation(featureLayerWrapper: FeatureLayerWrapper, template: any) {
        let creationInfo: CreationInfo = {
            layer: featureLayerWrapper.layer,
            template: template
        };
        await this.editor.startCreateFeaturesWorkflowAtFeatureCreation(creationInfo);
    }
    
    async startCreateFeaturesWorkflowAtFeatureTypeSelection() {
        await this.editor.startCreateFeaturesWorkflowAtFeatureTypeSelection();
    }
    
    async startUpdateWorkflowAtFeatureEdit(dotNetFeature: DotNetGraphic) {
        let feature = graphicsRefs[dotNetFeature.id];
        await this.editor.startUpdateWorkflowAtFeatureEdit(feature);
    }
    
    async startUpdateWorkflowAtFeatureSelection() {
        await this.editor.startUpdateWorkflowAtFeatureSelection();
    }
    
    async startUpdateWorkflowAtMultipleFeatureSelection(dotNetFeatures: DotNetGraphic[]) {
        let features = dotNetFeatures.map(dnf => graphicsRefs[dnf.id]);
        await this.editor.startUpdateWorkflowAtMultipleFeatureSelection(features);
    }
}